import { defineComponent } from "vue";
import { mapState } from "pinia";
import { Container } from "aurelia-dependency-injection";

import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";
import { ReferralService } from "../../../../../../services/referral-service";
import { ApplicationEnum, EvacuationZone, PhoneTypeEnum } from "../../../../../../enums/enums";
import { IApplicationAndAccountQueryParam } from "../../../../../../resources-vue/vue-interfaces/i-get-referral";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { Address } from "../../../../../../resources-vue/vue-models/address";

import PhoneNumber from "../../../../../../resources-vue/vue-custom-elements/PhoneNumber/PhoneNumber.vue";
import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import AddressForm from "../../AddressForm/AddressForm.vue";

export default defineComponent({
    components: {
        PhoneNumber,
        FormSection,
        AddressForm
    },

    computed: {
        ...mapState(useConvertToPendingPal, {
            accountId: "accountId",
            patientId: "patientId",
            patient: "patientDetails",
            application: "application",
            patientReferralId: "patientReferralId"
        })
    },

    data() {
        return {
            _referralService: null,
            isHisSection: true,
            isRequired: false,
            disableInputs: false,
            evacuationZoneEnum: EvacuationZone,
            phoneNumberOptions: [PhoneTypeEnum.Home, PhoneTypeEnum.Mobile, PhoneTypeEnum.Facility],
            isEvacuationAddressSameAsEmergencyContact: false,
            evacuationPrimaryPhoneNumber: {
                number: "",
                extension: "",
                type: 1,
                country: null,
                isPrimary: true
            },
            evacuationAlternatePhoneNumber: {
                number: "",
                extension: "",
                type: 1,
                country: null,
                isPrimary: true
            },
            enumToMap
        };
    },
    created() {
        this._referralService = Container.instance.get(ReferralService);
        if (this.patient?.emergencyPreparedness.evacuationPrimaryPhoneNumber == null) {
            this.patient.emergencyPreparedness.evacuationPrimaryPhoneNumber = this.evacuationPrimaryPhoneNumber;
        }
        if (this.patient?.emergencyPreparedness.evacuationAlternatePhoneNumber == null) {
            this.patient.emergencyPreparedness.evacuationAlternatePhoneNumber = this.evacuationAlternatePhoneNumber;
        }
        if (this.patient?.emergencyPreparedness.evacuationAddress == null) {
            this.patient.emergencyPreparedness.evacuationAddress = new Address();
        }
    },

    watch: {
        async isEvacuationAddressSameAsEmergencyContact(newValue: boolean) {
            if (!!this.patient) {
                if (newValue === true) {
                    this.disableInputs = true;
                    this.patient.emergencyPreparedness.isEvacuationAddressSameAsEmergencyContact = true;
                    const contact = await this.getAuthorizedContacts(this.patientReferralId as string);
                    if (contact) {
                        const address = contact.find((phone: any) => phone.isEmergencyContact)?.address;
                        this.patient.emergencyPreparedness.evacuationAddress = new Address(address);
                    }
                } else {
                    this.disableInputs = false;
                    this.patient.emergencyPreparedness.isEvacuationAddressSameAsEmergencyContact = false;
                    this.patient.emergencyPreparedness.evacuationAddress = new Address();
                }
            }
        }
    },

    methods: {
        async getAuthorizedContacts(id: string) {
            const payload: IApplicationAndAccountQueryParam = {
                application: ApplicationEnum.AxxessPalliative,
                agencyId: this.accountId as string
            };
            return this._referralService.getContacts(id, payload);
        }
    }
});
